
import React, { useState } from 'react';

import style from '../../../css/admin/Workshopupload.module.css';
import Communitydata from './Community_table_data';


const Community_upload = () => {
 

  return (
    <>
    <div className={style.uploadContainer}>
  <button
    className={style.uploadButton}
    onClick={() => window.open('/uploadcommunitypage', '_blank')}
  >
    <i className="fa-solid fa-cloud-arrow-up"></i> Community
  </button>
</div>
  <Communitydata />

    </>
  );
};

export default Community_upload;